 <!-- 
   <svelte:head>
    <link href="https://fonts.googleapis.com/css?family=Raleway:100,200,300,400,500,600,700,800,900&display=swap" rel="stylesheet">

    <title>en-curta.me</title>



Breezed Template

https://templatemo.com/tm-543-breezed


    <!-- Additional CSS Files 
    <link rel="stylesheet" type="text/css" href="assets/css/bootstrap.min.css">

    <link rel="stylesheet" type="text/css" href="assets/css/font-awesome.css">

    <link rel="stylesheet" href="assets/css/templatemo-breezed.css">

    <link rel="stylesheet" href="assets/css/owl-carousel.css">

   <!-- <link rel="stylesheet" href="assets/css/lightbox.css">
   <script src="assets/js/jquery-2.1.0.min.js"></script>

    <!-- Bootstrap 
    <script src="assets/js/popper.js"></script>
    <script src="assets/js/bootstrap.min.js"></script>

    <!-- Plugins 
   <!-- <script src="assets/js/owl-carousel.js"></script>
    <script src="assets/js/scrollreveal.min.js"></script>
    <script src="assets/js/waypoints.min.js"></script>
    <script src="assets/js/jquery.counterup.min.js"></script>
    <script src="assets/js/imgfix.min.js"></script> 
    <script src="assets/js/slick.js"></script> 
    <script src="assets/js/lightbox.js"></script> 
    <script src="assets/js/isotope.js"></script> 
    
    <!-- Global Init 
    <script src="assets/js/custom.js"></script>

    
   </svelte:head>

   -->
   <script>
   import Nav from "./nav.svelte";
   import {createEventDispatcher, tick } from 'svelte';
    

  
const dispatch = createEventDispatcher();


$:innerWidth=0;
$:innerHeight=0;
$:outerWidth=0;

function FaleConosco(e){
    e.preventDefault();
    window.location.href="https://api.whatsapp.com/send?phone=5581996280325"
    //window.location.href="http://localhost:5000/index.html?teste=teste"

}

function ChamarTela (e){
    dispatch("ChamarTela", e); 
    
}
  
   </script>
   
    <svelte:window bind:innerWidth bind:outerWidth bind:innerHeight />
   
    <html  lang="pt-br"> 
  
    <body>
    
    <!-- ***** Preloader Start *****
    <div id="preloader">
        <div class="jumper">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>  
     ***** Preloader End ***** -->
    
     
    <!-- ***** Header Area Start ***** 
    <header class="header-area header-sticky">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <nav class="main-nav">
                        <!-- ***** Logo Start ***** 
                        <a href="index.html" class="logo">
                            Microssites
                        </a>
                        <!-- ***** Logo End ***** 
                        <!-- ***** Menu Start ***** 
                        <ul class="nav">
                            <li class="scroll-to-section"><a href=" " class="active">Home</a></li>
                            <li class="scroll-to-section"><a href=" ">Logar</a></li>
                            <li class="scroll-to-section"><a href=" ">Cadastrar</a></li>
                            
                            <li class="scroll-to-section"><a href="#contact-us">Fale conosco</a></li> 
                           <!-- <div class="search-icon">
                                <a href="#search"><i class="fa fa-search"></i></a>
                            </div>
                        </ul>        
                        <!--<a class='menu-trigger' href=" "> 
                            <span>Menu</span>
                        </a>-->
                        <!-- ***** Menu End ***** 
                    </nav>   
                </div>
            </div>
        </div>  
    </header>-->
    <!-- ***** Header Area End ***** -->
    
    <!-- ***** Search Area ***** 
    <div id="search">
        <button type="button" class="close">×</button>
        <form id="contact" action="#" method="get">
            <fieldset>
                <input type="search" name="q" placeholder="SEARCH KEYWORD(s)" aria-label="Search through site content">
            </fieldset>
            <fieldset>
                <button type="submit" class="main-button">Search</button>
            </fieldset>
        </form>
    </div>-->

    <!-- ***** Main Banner Area Start ***** -->
    
    <div class="main-banner header-text" id="top">
        <div class="Modern-Slider"> 
          <!-- Item -->
          <div class="item">
            <div class="img-fill imagem-back">
            {#if innerWidth>600 && innerWidth>innerHeight}
                <img src="assets/images/slide-01.jpg" class="img-fluid" alt="">
            {:else if innerWidth<innerHeight}
                 <img src="assets/images/slide5.jpg" class="img-fluid" alt="">
            {/if}
                <div class="text-content">
                
                  <h3>Bem vindo(a) ao novo conceito de cartão de visita e site</h3>
                  <h5>Microssites en-curta.me</h5>
                  
                 <!-- <a href=" " class="main-stroked-button">Learn More</a> -->
                  <a  class="main-filled-button" on:click={(e)=>ChamarTela("login")}>Quero fazer um microssite</a>
                </div>
            </div>
          </div>
          <!-- // Item -->
          <!-- Item 
          <div class="item">
            <div class="img-fill">
                <img src="assets/images/slide-02.jpg" alt="">
                <div class="text-content">
                  <h3>Integrated Marketing Media</h3>
                  <h5>Best Digital Marketing</h5>
                  <a href=" " class="main-stroked-button">Read More</a>
                  <a href=" " class="main-filled-button">Take Action</a>
                </div>
            </div>
          </div>
           Item -->
          <!-- Item 
          <div class="item">
            <div class="img-fill">
                <img src="assets/images/slide-03.jpg" alt="">
                <div class="text-content">
                  <h3>High Performance</h3>
                  <h5>Robust and Speedy</h5>
                  <a href=" " class="main-stroked-button">Learn More</a>
                  <a href=" " class="main-filled-button">Get It Now</a>
                </div>
            </div>
          </div>
          // Item -->
        </div>
    </div>
    <div class="scroll-down scroll-to-section"><a href="#about"><i class="fa fa-arrow-down"></i></a></div>
    <!-- ***** Main Banner Area End ***** -->

    <!-- ***** About Area Starts ***** -->
    <section class="section" id="about">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                    <div class="left-text-content">
                        <div class="section-heading">
                            <h6>O que é um microssite</h6>
                            <h2>A união de dois mundos. Um cartão de visita virtual hospedado!</h2>
                        </div>
                        <div class="row text-center">

                            <div class="col-md-6 col-sm-6">
                                <div class="text-center ml-5">
                                    <img src="img/celular.png" class="img-thumbnail" alt="">
                                    
                                </div>
                            </div>
                        
                        <!--
                            <div class="col-md-6 col-sm-6">
                                <div class="service-item">
                                    <img src="assets/images/service-item-01.png" alt="">
                                    <h4>Robust</h4>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="service-item">
                                    <img src="assets/images/contact-info-03.png" alt="">
                                    <h4>Reliable</h4>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="service-item">
                                    <img src="assets/images/contact-info-03.png" alt="">
                                    <h4>Up-to-date</h4>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <a href=" " class="main-button-icon">
                                    Learn More <i class="fa fa-arrow-right"></i>
                                </a>
                            </div>

                            -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                    <div class="right-text-content">
                        <p>Na era digital, os antigos cartões de visita confeccionados em papel não mais atendem as necessidades do mundo moderno.
                        <br><br>Por outro lado, os cartões virtuais de visitas em formato de arquivo de leitura (pdf) não tem um longo alcance, uma vez que nem sempre podem ser divulgados  em todas as plataformas digitais e redes sociais.
                      <br><br>A informação no mundo atual requer presteza e qualidade, de modo que os sites complexos e pouco intuitivos não tem mais espaço para o consumidor exigente.
                      <br>Microssite é objetivo, prático e fácil de manusear. Reune todos os seus contatos em um só lugar e deixa à sua disposição um link que pode ser colocado onde você quiser, como por exemplo na BIO do Instagram. E o melhor de tudo: é GRÁTIS. <a href= " " on:click={(e)=>ChamarTela("login")}> Faça o seu agora mesmo.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ***** About Area Ends ***** -->

    <!-- ***** Features Big Item Start ***** -->
    <section class="section" id="features">
        <div class="container  text-center"><hr>
            <div class="row"><div class="col-12 justify-content mb-5"><h1>Alguns microssites</h1></div></div>
            <div class="row">
            
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12" data-scroll-reveal="enter left move 30px over 0.6s after 0.4s">
                    <div class="features-item">
                     <div class="text-center">
                      <h4 class="">Empório frios</h4>
                            <img src="img/emporiocel.png" class="cel-pequeno m-2" alt="" >
                     </div>
                     <div class="text-center">
                             <a href="http://en-curta.me/_emporiofrios " class="">
                                en-curta.me/_emporiofrios <i class="fa fa-arrow-right"></i>
                            </a>
                      </div>
                         
                        <!--<div class="features-icon">
                            <img src="assets/images/features-icon-1.png" alt="">
                        </div>-->
                        <div class="features-content">
                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12" data-scroll-reveal="enter bottom move 30px over 0.6s after 0.4s">
                   <div class="features-item">
                     <div class="text-center">
                      <h4 class="">Link Agenda</h4>
                            <img src="img/linkagendacel.png" class="cel-pequeno m-2" alt="" >
                     </div>
                     <div class="text-center">
                             <a href="http://en-curta.me/_linkagenda" class="">
                                en-curta.me/_linkagenda <i class="fa fa-arrow-right"></i>
                            </a>
                      </div>
                         
                        <!--<div class="features-icon">
                            <img src="assets/images/features-icon-1.png" alt="">
                        </div>-->
                        <div class="features-content">
                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12" data-scroll-reveal="enter right move 30px over 0.6s after 0.4s">
                        <div class="features-item">
                     <div class="text-center">
                      <h5 class="">Dra. Luciana Barros</h5>
                            <img src="img/lucianacelular.png" class="cel-pequeno m-2" alt="" >
                     </div>
                     <div class="text-center">
                             <a href="http://en-curta.me/Dra_LucianaBarros" class="">
                                en-curta.me/Dra_LucianaBarros <i class="fa fa-arrow-right"></i>
                            </a>
                      </div>
                         
                        <!--<div class="features-icon">
                            <img src="assets/images/features-icon-1.png" alt="">
                        </div>-->
                        <div class="features-content">
                            
                        </div>
                    </div>
                </div>
                 <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12" data-scroll-reveal="enter right move 30px over 0.6s after 0.4s">
                        <div class="features-item">
                     <div class="text-center">
                      <h4 class="">Thiago Barreto</h4>
                            <img src="img/thiagocelular.png" class="cel-pequeno m-2" alt="" >
                     </div>
                     <div class="text-center">
                             <a href="http://en-curta.me/Dra_LucianaBarros" class="">
                                en-curta.me/_thiagobarreto <i class="fa fa-arrow-right"></i>
                            </a>
                      </div>
                         
                        <!--<div class="features-icon">
                            <img src="assets/images/features-icon-1.png" alt="">
                        </div>-->
                        <div class="features-content">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ***** Features Big Item End ***** -->

    <!-- ***** Features Big Item Start ***** -->
    <section class="section" id="subscribe">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="section-heading">
                        <h6>Conheça nossos planos</h6>
                        <h2>Faça você mesmo ou conte conosco!</h2>
                    </div>
                    <div class="subscribe-content">
                        <p>Quer fazer você mesmo e não quer investir nada ? Não tem problema. Temos um plano gratuito para você criar seu próprio microssite.</p>
                        <p>Quer um microssite mas não quer fazer você mesmo? Temos a solução, assine um plano com assistência profissional e deixe-nos fazer seu microssite.</p>
                        <div class="subscribe-form">
                            <form id="subscribe-now" action="" method="get">
                                <div class="row">
                                <!--
 <div class="col-md-8 col-sm-12">
                                      <fieldset>
                                        <input name="email" type="text" id="email" placeholder="Enter your email..." required="">
                                      </fieldset>
                                    </div>


                                -->
                                   
                                    <div class="col-12 text-center">
                                      <fieldset>
                                        <button type="submit" id="form-submit" class="main-button" on:click={(e)=>ChamarTela("planos")}>Conheça nossos planos</button>
                                      </fieldset>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ***** Features Big Item End ***** -->


    <!-- ***** Projects Area Starts *****
    <section class="section" id="projects">
      <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <div class="section-heading">
                    <h6>Our Projects</h6>
                    <h2>Some of our latest projects</h2>
                </div>
                <div class="filters">
                    <ul>
                        <li class="active" data-filter="*">All</li>
                        <li data-filter=".des">Web Design</li>
                        <li data-filter=".dev">Web Development</li>
                        <li data-filter=".gra">Graphics</li>
                        <li data-filter=".tsh">Artworks</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="filters-content">
                    <div class="row grid">
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 all des">
                          <div class="item">
                            <a href="assets/images/project-big-item-01.jpg" data-lightbox="image-1" data-title="Our Projects"><img src="assets/images/project-item-01.jpg" alt=""></a>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 all dev">
                          <div class="item">
                            <a href="assets/images/project-big-item-02.jpg" data-lightbox="image-1" data-title="Our Projects"><img src="assets/images/project-item-02.jpg" alt=""></a>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 all gra">
                          <div class="item">
                            <a href="assets/images/project-big-item-03.jpg" data-lightbox="image-1" data-title="Our Projects"><img src="assets/images/project-item-03.jpg" alt=""></a>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 all tsh">
                          <div class="item">
                            <a href="assets/images/project-big-item-04.jpg" data-lightbox="image-1" data-title="Our Projects"><img src="assets/images/project-item-04.jpg" alt=""></a>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 all dev">
                          <div class="item">
                            <a href="assets/images/project-big-item-05.jpg" data-lightbox="image-1" data-title="Our Projects"><img src="assets/images/project-item-05.jpg" alt=""></a>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12 all des">
                          <div class="item">
                            <a href="assets/images/project-big-item-06.jpg" data-lightbox="image-1" data-title="Our Projects"><img src="assets/images/project-item-06.jpg" alt=""></a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>
    <!-- ***** Projects Area Ends ***** -->

    <!-- ***** Testimonials Starts *****
    <section class="section" id="testimonials">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-heading">
                        <h6>Digital Team</h6>
                        <h2>young and talented members</h2>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 mobile-bottom-fix-big" data-scroll-reveal="enter left move 30px over 0.6s after 0.4s">
                    <div class="owl-carousel owl-theme">
                        <div class="item author-item">
                            <div class="member-thumb">
                                <img src="assets/images/member-item-01.jpg" alt="">
                                <div class="hover-effect">
                                    <div class="hover-content">
                                        <ul>
                                            <li><a href=" "><i class="fa fa-facebook"></i></a></li>
                                            <li><a href=" "><i class="fa fa-twitter"></i></a></li>
                                            <li><a href=" "><i class="fa fa-linkedin"></i></a></li>
                                            <li><a href=" "><i class="fa fa-rss"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h4>.01 White Cheese</h4>
                            <span>Digital Marketer</span>
                        </div>
                        <div class="item author-item">
                            <div class="member-thumb">
                                <img src="assets/images/member-item-04.jpg" alt="">
                                <div class="hover-effect">
                                    <div class="hover-content">
                                        <ul>
                                            <li><a href=" "><i class="fa fa-facebook"></i></a></li>
                                            <li><a href=" "><i class="fa fa-twitter"></i></a></li>
                                            <li><a href=" "><i class="fa fa-linkedin"></i></a></li>
                                            <li><a href=" "><i class="fa fa-rss"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h4>.02 Snow Mary</h4>
                            <span>Site Analyst</span>
                        </div>
                        <div class="item author-item">
                            <div class="member-thumb">
                                <img src="assets/images/member-item-02.jpg" alt="">
                                <div class="hover-effect">
                                    <div class="hover-content">
                                        <ul>
                                            <li><a href=" "><i class="fa fa-facebook"></i></a></li>
                                            <li><a href=" "><i class="fa fa-twitter"></i></a></li>
                                            <li><a href=" "><i class="fa fa-linkedin"></i></a></li>
                                            <li><a href=" "><i class="fa fa-rss"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h4>.03 Johnny Egg</h4>
                            <span>Digital Influencer</span>
                        </div>
                        <div class="item author-item">
                            <div class="member-thumb">
                                <img src="assets/images/member-item-05.jpg" alt="">
                                <div class="hover-effect">
                                    <div class="hover-content">
                                        <ul>
                                            <li><a href=" "><i class="fa fa-facebook"></i></a></li>
                                            <li><a href=" "><i class="fa fa-twitter"></i></a></li>
                                            <li><a href=" "><i class="fa fa-linkedin"></i></a></li>
                                            <li><a href=" "><i class="fa fa-rss"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h4>.04 Catherine Phyu</h4>
                            <span>Co Founder</span>
                        </div>
                        <div class="item author-item">
                            <div class="member-thumb">
                                <img src="assets/images/member-item-03.jpg" alt="">
                                <div class="hover-effect">
                                    <div class="hover-content">
                                        <ul>
                                            <li><a href=" "><i class="fa fa-facebook"></i></a></li>
                                            <li><a href=" "><i class="fa fa-twitter"></i></a></li>
                                            <li><a href=" "><i class="fa fa-linkedin"></i></a></li>
                                            <li><a href=" "><i class="fa fa-rss"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h4>.05 Shao Lynn</h4>
                            <span>Chief Marketing</span>
                        </div>
                        
                        <div class="item author-item">
                            <div class="member-thumb">
                                <img src="assets/images/member-item-04.jpg" alt="">
                                <div class="hover-effect">
                                    <div class="hover-content">
                                        <ul>
                                            <li><a href=" "><i class="fa fa-facebook"></i></a></li>
                                            <li><a href=" "><i class="fa fa-twitter"></i></a></li>
                                            <li><a href=" "><i class="fa fa-linkedin"></i></a></li>
                                            <li><a href=" "><i class="fa fa-rss"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h4>.06 Emma Honey</h4>
                            <span>Digital Influencer</span>
                        </div>
                        
                        <div class="item author-item">
                            <div class="member-thumb">
                                <img src="assets/images/member-item-06.jpg" alt="">
                                <div class="hover-effect">
                                    <div class="hover-content">
                                        <ul>
                                            <li><a href=" "><i class="fa fa-facebook"></i></a></li>
                                            <li><a href=" "><i class="fa fa-twitter"></i></a></li>
                                            <li><a href=" "><i class="fa fa-linkedin"></i></a></li>
                                            <li><a href=" "><i class="fa fa-rss"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h4>.07 Oliva Sofie</h4>
                            <span>Website Analyst</span>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>
     ***** Testimonials Ends ***** -->
    
    <!-- ***** Contact Us Area Starts ***** -->  
    <section class="section" id="contact-us">
        <div class="container ">
            <div class="row  ">
                <div class="col-12 text-center">
                    <div class="left-text-content">
                        <div class="section-heading">
                            <h6>Ainda tem alguma dúvida?</h6>
                            <h2>Contate-nos!</h2>
                        </div>
                        <ul class="contact-info">
                            <li><img src="assets/images/contact-info-01.png" alt="">81 99628-0325</li>
                            <li><img src="assets/images/contact-info-02.png" alt="">comercial@andlline.com.br</li>
                             <button type="submit" id="form-submit" class="main-button-icon" on:click={FaleConosco}>Fale com nosso whatsapp <i class="fa fa-arrow-right"></i></button>
                  
                        </ul>

                    </div>
                </div>
               
                <div class="col-lg-8 col-md-8 col-xs-12">
                    <div class="contact-form">
                       <!-- <form id="contact" action="" method="get">
                          <div class="row">
                            <div class="col-md-6 col-sm-12">
                              <fieldset>
                                <input name="name" type="text" id="name" placeholder="Your Name *" required="">
                              </fieldset>
                            </div>
                            <div class="col-md-6 col-sm-12">
                              <fieldset>
                                <input name="phone" type="text" id="phone" placeholder="Your Phone" required="">
                              </fieldset>
                            </div>
                            <div class="col-md-6 col-sm-12">
                              <fieldset>
                                <input name="email" type="email" id="email" placeholder="Your Email *" required="">
                              </fieldset>
                            </div>
                            <div class="col-md-6 col-sm-12">
                              <fieldset>
                                <input name="subject" type="text" id="subject" placeholder="Subject">
                              </fieldset>
                            </div>
                            <div class="col-lg-12">
                              <fieldset>
                                <textarea name="message" rows="6" id="message" placeholder="Message" required=""></textarea>
                              </fieldset>
                            </div>
                            <div class="col-lg-12">
                              <fieldset>
                                <button type="submit" id="form-submit" class="main-button-icon">Send Message Now <i class="fa fa-arrow-right"></i></button>
                              </fieldset>
                            </div>
                          </div>
                        </form> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ***** Contact Us Area Ends ***** -->
    
    <!-- ***** Footer Start ***** -->
    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-xs-12">
                    <div class="left-text-content">
                        <p>Copyright Andlline Software; 2020 
                         
                        </p>
                    </div>
                </div>
               <!-- <div class="col-lg-6 col-xs-12">
                    <div class="right-text-content">
                            <ul class="social-icons">
                                <li><p>Follow Us</p></li>
                                <li><a rel="nofollow" href="https://fb.com/templatemo"><i class="fa fa-facebook"></i></a></li>
                                <li><a rel="nofollow" href="https://fb.com/templatemo"><i class="fa fa-twitter"></i></a></li>
                                <li><a rel="nofollow" href="https://fb.com/templatemo"><i class="fa fa-linkedin"></i></a></li>
                                <li><a rel="nofollow" href="https://fb.com/templatemo"><i class="fa fa-dribbble"></i></a></li>
                            </ul>
                    </div>
                </div>-->
            </div>
        </div>
    </footer>
    

    <!-- jQuery -->
    

  </body>
</html>

<style>
.logo-pequena{
    max-width: 200px;
}
.cel-pequeno{
    max-width: 10rem;
}
.imagem-back{
    background:contain;
}
</style>